import { Component, Input, OnInit } from '@angular/core';
import { Cloudinary, XmStore, XmStoreUtil } from 'core/services';
import { Subscription } from 'rxjs';
import { CmsDataDetail } from 'store/cms/models';

@Component({
    selector: 'fcc-badge',
    styleUrls: ['./fcc-badge.scss'],
    templateUrl: './fcc-badge.html',
    standalone: false
})
export class XmFccBadgeComponent implements OnInit {
    @Input() public isInUse: boolean = false;
    public pageData: CmsDataDetail;
    public inUseIcon: MediaImageOptions;
    public cbmLabelContent: CBMLabelDetails;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.pageData = pageData;
            this.cbmLabelContent = pageData.cbmBroadbandLabelContent;
            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.inUseIcon)
            };
        }));
    }
}
